import { Controller } from "@hotwired/stimulus"

// Checks or unchecks every checkbox target at once (select all / deselect all).
export default class extends Controller {
  static targets = ["checkbox"]

  checkAll() {
    this._setAll(true)
  }

  uncheckAll() {
    this._setAll(false)
  }

  _setAll(checked) {
    this.checkboxTargets.forEach(checkbox => checkbox.checked = checked)
  }
}
